import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.447 3.001a.7.7 0 0 1 .661.736l-.15 2.804h4.334l.154-2.878a.7.7 0 1 1 1.398.074l-.15 2.804H16.3a.7.7 0 1 1 0 1.4h-2.68l-.22 4.098h2.9a.7.7 0 1 1 0 1.4h-2.974l-.155 2.898a.7.7 0 1 1-1.398-.074l.15-2.824H7.592l-.155 2.898a.7.7 0 1 1-1.398-.074l.15-2.824H3.7a.7.7 0 1 1 0-1.4h2.563l.219-4.098H3.7a.7.7 0 1 1 0-1.4h2.857l.153-2.878A.7.7 0 0 1 7.447 3m.437 4.94-.219 4.098H12l.218-4.098z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=HashmarkIcon20.js.map